import { CertificationsTable } from '../components/certificationsIndex/CertificationsTable';
import ErrorBoundary from '../../../components/Errors/ErrorBoundary';
import Filters from '../components/filters/Filters';
import { useCertificationsTableStore } from '../store/myTeamTableStateStore';
import { PAGE_NAMES } from '../../../constants/Navigation.legacy';
import UsageTracker from '../../../utils/UsageTracker';
import { useEffect } from 'react';
import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { PageHeader } from 'academy-common-lib/features/header/components/PageHeader';
import Card from '../components/common/Card';
import { getBreadcrumbItem } from '../constants/breadcrumbs';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MyTeamCertificationsIndex = () => {
  const store = useCertificationsTableStore();
  const breadcrumbs = [getBreadcrumbItem({
    pageKey: 'MY_TEAM'
  }), getBreadcrumbItem({
    pageKey: 'MY_TEAM_CERTIFICATIONS',
    isCurrent: true
  })];
  useEffect(() => {
    UsageTracker.track('pageView', {
      screen: PAGE_NAMES.MY_TEAM_CERTIFICATIONS
    });
  }, []);
  return /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsx(PageHeader, {
      breadcrumbs: breadcrumbs,
      subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.heading.headingSubTitles.MY_TEAM_CERTIFICATIONS"
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.heading.headingTitles.MY_TEAM_CERTIFICATIONS"
      })
    }), /*#__PURE__*/_jsxs(Card, {
      children: [/*#__PURE__*/_jsx(Filters, {
        store: store
      }), /*#__PURE__*/_jsx(ErrorBoundary, {
        boundaryName: "CertificationsTable",
        children: /*#__PURE__*/_jsx(CertificationsTable, {})
      })]
    })]
  });
};
export default MyTeamCertificationsIndex;